// Das kleine Kennzeichen-Abzeichen links in den Listen der Statistik-
// Unterseiten (docs/reference/statistik-detail-bb-nichtgesehen.png,
// 08.09.2026).
//
// Zwei Fassungen, und der Unterschied ist der Punkt: aktuelle Zeichen
// tragen das blaue Euro-Band mit Sternenkranz, historische ein leeres
// weisses Schild mit schwarzem Rand - so, wie die Schilder vor der
// Euro-Band-Zeit aussahen. Ohne diese Unterscheidung sieht ein Zeichen von
// 1994 aus wie eines von heute.

import type { Land } from "../lib/bundle.js";
import { Flaggenband } from "./Flaggenband.js";

const BREITE = 28;
const HOEHE = 44;

export function Kennzeichenabzeichen({
  land,
  historisch,
}: {
  land: Land | undefined;
  historisch: boolean;
}) {
  if (!historisch) {
    return (
      <Flaggenband
        land={land}
        breite={BREITE}
        hoehe={HOEHE}
        sternGroesse={14}
        schriftKlasse="text-[10px]"
        gerundet
      />
    );
  }
  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-sm border-2 border-black bg-white"
      style={{ width: BREITE, height: HOEHE }}
    >
      <span className="text-[10px] font-bold text-black">
        {land?.plateLetter}
      </span>
    </div>
  );
}
